<template>
  <!-- Content Wrapper. Contains page content -->

  <div>
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <br />

      <ul>
        <li v-for="(endereco, idx) of enderecos" :key="idx">
          <button
            style="
              border-radius: 3em;
              width: -webkit-fill-available;
              background-color: #888;
              align-items: center;
              margin-top: 5px;
              margin-bottom: 5px;
              color: white;
            "
            class="btn"
            @click="retornar_cd_endereco($event), salvarEndereco(endereco)"
            :id="endereco.cd"
          >
            Estado: {{ endereco.uf }}
            <br />
            Cidade: {{ endereco.nm_cid }}
            <br />
            Bairro: {{ endereco.bairro }}
            <br />
            Rua: {{ endereco.rua }}
            <br />
            Complemento: {{ endereco.complemento }}
            <br />
            Referência: {{ endereco.proximidade }}
          </button>
        </li>
      </ul>

<!--       <button
        style="align-items: center; margin-top: 5px; margin-bottom: 5px"
        class="btn btn-dark"
        @click="push()"
      >
        Cadastrar novo endereço
      </button> -->
      <!-- <button
        style="align-items: center; margin-top: 5px; margin-bottom: 5px"
        class="btn btn-dark"
        @click="deletarEndereco()"
      >
        Apagar Endereço
      </button> -->
      <!-- <button
        style="align-items: center; margin-top: 5px; margin-bottom: 5px"
        class="btn btn-dark"
        @click="salvarVenda(products, cd_usuario)"
      >
        Finalizar pedido
      </button> -->
    </div>
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Cardapio from "../services/cardapio";
import store from "../store/index.js";
import Adicional from "../services/adicional";
import Ordem from "../services/nome_ordem";
import Contrato from "../services/contrato";
import ItemVenda from "../services/item_venda";
import Usuario from "../services/usuario";
import Endereco from "../services/endereco";
import Venda from "../services/venda";
import Swal from "sweetalert2";


export default {
  name: "ListaEnderecos",
  data() {
    return {
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      email: "",
      enderecos: {},
      cd_usuario: "",
      usuarios: [],
      cd: "",
      checkedRetirarLocal: "",
      logadoAux: "",
      codigoEndereco: "",
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
      logado: "retornaLogado",
    }),
    total() {
      return this.products.reduce((total, p) => {
        return total + p.vl * p.quantity;
      }, 0);
    },
  },
  methods: {
    push() {
      this.email = localStorage.getItem("email"+localStorage.getItem('contrato'));
      this.$router.push("/endereco");
    },
    
    listandoEnderecos() {
      var cdUsu = localStorage.getItem("cd"+ localStorage.getItem('contrato'));
      Endereco.listandoEnderecos(cdUsu).then((resposta) => {
        this.enderecos = resposta.data;
      });
    },
   
    retornar_cd_endereco(evento) {
      this.cd = evento.target.id;
    },
    verificaLogado(){
      if (this.logado==false){
        this.$router.push('/login')
      }
    }
  },
  mounted() {
    this.verificaLogado();
    this.listandoEnderecos();
    this.email = localStorage.getItem("email"+localStorage.getItem('contrato'));
  },
};
</script>